import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import ProtectedSection from './ProtectedSection';
import printSettingsService from '../services/printSettingsService';
import { buildViewPdfHtml, openPrintWindow } from '../utils/printHelpers';

export default function ViewPdfButton({
  getDocument,
  label = 'Téléchargement PDF',
  variant = 'outline-dark',
  size = 'sm',
  className = '',
}) {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    try {
      setLoading(true);

      const [settings, doc] = await Promise.all([
        printSettingsService.get(),
        Promise.resolve(getDocument()),
      ]);

      const html = buildViewPdfHtml({
        title: doc?.title || 'Document',
        settings,
        sections: doc?.sections || [],
      });

      openPrintWindow({
        title: doc?.title || 'Document',
        bodyHtml: html,
      });
    } catch (e) {
      console.error(e);
      alert(
        e?.response?.data?.message ||
          e?.message ||
          "Impossible de générer le PDF."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <ProtectedSection code="PRINT_DOWNLOAD">
      <Button
        variant={variant}
        size={size}
        className={className}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? 'Préparation…' : label}
      </Button>
    </ProtectedSection>
  );
}